<template>
  <div class="products-availabilities-view">
    <data-grid
      :columns="gridColumns"
      :is-loading="isLoading"
      :page-info="productAvailabilities.pagination"
      :rows="productAvailabilities.entries"
      :sort-info="productAvailabilities.sort"
      :sortable="['provider', 'stock', 'deliveryLeadTime', 'updatedAt']"
      @sort="sortBy"
      class="uk-margin-medium"
      v-if="gridLoaded"
    >
      <template scope="props" slot="provider">
        <provider-name :name="props.row.provider" />
      </template>
      <template scope="props" slot="deliveryLeadTime">
        <delivery-lead-time
          :value="props.row.deliveryLeadTime"
          v-if="props.row.deliveryLeadTime"
        />
        <text-placeholder v-else />
      </template>
      <template scope="props" slot="updatedAt">
        <timeago :auto-update="60" :since="props.row.updatedAt" />
      </template>
      <template scope="props" slot="actions">
        <data-grid-actions
          @edit="editProductAvailability(props.row)"
          @remove="deleteRecordWhenConfirmed(props.row)"
          class="data-grid__actions"
          editable
          removable
        />
      </template>
    </data-grid>

    <div
      class="loader-container uk-container uk-margin-medium-top uk-text-center"
      v-else
    >
      <loader />
    </div>

    <product-availability-editor
      @change="refetchList"
      ref="productAvailabilityEditor"
    />

    <common-button
      @click="addProductAvailability"
      icon="plus"
      type="primary"
    >{{$t('actions.add')}}</common-button>
  </div>
</template>

<script>
import Authentication from '@/mixins/Authentication';
import CommonButton from '@/components/CommonButton';
import DataGridActions from '@/components/DataGridActions';
import DeliveryLeadTime from '@/components/DeliveryLeadTime';
import deleteProductAvailabilityMutation
  from '@/api/mutations/delete-product-availability.graphql';
import IndexView from '@/mixins/IndexView';
import ProductAvailabilityEditor from '@/components/ProductAvailabilityEditor';
import productAvailabilitiesQuery
  from '@/api/queries/product-availabilities.graphql';
import ProviderName from '@/components/ProviderName';
import TextPlaceholder from '@/components/TextPlaceholder';

export default {
  name: 'products-availabilities-view',
  mixins: [
    Authentication,
    IndexView('productAvailabilities', {
      gridFields: ['provider', 'stock', 'deliveryLeadTime', 'updatedAt'],
      listQuery: productAvailabilitiesQuery,
      deleteMutation: deleteProductAvailabilityMutation,
      nameField: 'provider',
      defaultFilter() {
        return { productId: this.product.id };
      },
      defaultSort: { field: 'PROVIDER', direction: 'ASC' },
    }),
  ],
  components: {
    CommonButton,
    DataGridActions,
    DeliveryLeadTime,
    ProductAvailabilityEditor,
    ProviderName,
    TextPlaceholder,
  },
  props: {
    product: Object,
  },
  computed: {
    breadcrumbs() {
      return [
        {
          key: 'show',
          text: () => this.$t('title'),
          route: { name: 'product-availabilities' },
          isLoading: false,
        },
      ];
    },
  },
  methods: {
    addProductAvailability() {
      this.$refs.productAvailabilityEditor.show(this.product);
    },
    editProductAvailability(availability) {
      this.$refs.productAvailabilityEditor.show(this.product, availability);
    },
  },
  i18n: {
    messages: {
      de: {
        actions: {
          add: 'Verfügbarkeit hinzufügen',
        },
        confirmations: {
          delete: 'Möchten Sie diese Verfügbarkeit löschen?',
        },
        title: 'Verfügbarkeit',
        toasts: {
          deleted: 'Verfügbarkeit wurde gelöscht.',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// AvailabilitiesView.vue?04ea7677